import React, { useMemo } from "react";
import { Card, Table } from "react-bootstrap";
import { FaIndustry } from "react-icons/fa";
import { CartographySupplier } from "./types";
import { buildSectorStats, getBadgeClass, getSectorColor } from "./cartographyUtils";

interface Props {
  suppliers: CartographySupplier[];
}

const SectorStatsTable: React.FC<Props> = ({ suppliers }) => {
  const stats = useMemo(() => buildSectorStats(suppliers), [suppliers]);

  return (
    <Card className="aida-panel-card h-100">
      <Card.Body>
        <div className="aida-section-heading mb-3">
          <div>
            <h5><FaIndustry /> Répartition par filière</h5>
            <p>Lecture des capacités industrielles par domaine de sous-traitance.</p>
          </div>
        </div>

        <div className="table-responsive aida-table-scroll-sm">
          <Table hover className="aida-table align-middle mb-0">
            <thead>
              <tr>
                <th>Filière</th>
                <th>Fourn.</th>
                <th>Produits</th>
                <th>Capacité</th>
                <th>Couverture</th>
                <th>Alertes</th>
              </tr>
            </thead>
            <tbody>
              {stats.map((item) => (
                <tr key={item.sector}>
                  <td>
                    <div className="aida-sector-cell">
                      <span style={{ background: getSectorColor(item.sector) }} />
                      <strong>{item.sector}</strong>
                    </div>
                  </td>
                  <td>{item.suppliers}</td>
                  <td>{item.products}</td>
                  <td>{item.capacity}</td>
                  <td>
                    <span className={getBadgeClass(item.coverageRate !== null ? "Capacitaire" : "Non renseigné")}>
                      {item.coverageRate !== null ? `${item.coverageRate}%` : "Non renseigné"}
                    </span>
                  </td>
                  <td>
                    <span className={item.alerts > 0 ? "aida-badge-danger" : "aida-badge-muted"}>{item.alerts}</span>
                  </td>
                </tr>
              ))}
              {stats.length === 0 && (
                <tr>
                  <td colSpan={6} className="text-center text-muted py-4">Aucune donnée filière disponible.</td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </Card.Body>
    </Card>
  );
};

export default SectorStatsTable;
